// src/utils/tunnelSortingByDistance.js

export const sortTunnelByDistance = (tunnelDistances) => {
  return Object.entries(tunnelDistances)
    .sort(([, distanceA], [, distanceB]) => distanceA - distanceB)
    .map(([abbr, distance]) => ({ abbr, distance }));
};